import React, { useState, useEffect } from "react";
import Plotly from "plotly.js-dist";

export const ProductivityChart = (props) => {
  const maxHeight = window.innerHeight - 230;

  // set chart data for Monthly values and Hourly values
  setTimeout(() => {
    var first_date = props.data[0].date;
    var last_date = props.data[props.data.length - 1];
    var charData = [
      {
        x: props.data.map((obj) => obj["date"]),
        y: props.data.map((obj) => obj["pow_alt_cur"].toFixed(0)),
        type: "line",
        name: props.title,
        hovertemplate:
          "<i>%{x}</i>" +
          "<br>Power in alternate current: %{y} kW<extra></extra>",
      },
      {
        x: props.data.map((obj) => obj["date"]),
        y: props.data.map((obj) => obj["load"].toFixed(0)),
        type: "line",
        name: "Load",
        hovertemplate:
          "<i>%{x}</i>" + "<br>Active power: %{y} kW<extra></extra>",
        line: {
          color: "#ED4949",
        },
      },
    ];
    // set chart layout
    var layout = {
      showlegend: true,
      legend: {
        orientation: "h",
        x: 0.4,
        y: -0.27,
      },
      margin: { t: 80, b: 15, l: 60, r: 30 },
      hovermode: "closest",
      title: {
        text: `${props.title} and Load Active Power (in kW)`,
        standoff: 10,
      },
      xaxis: {
        autorange: true,
        range: [first_date, last_date],
        rangeselector: {
          buttons: [
            {
              count: 1,
              label: "1 month",
              step: "month",
              stepmode: "backward",
            },
            {
              count: 6,
              label: "6 months",
              step: "month",
              stepmode: "backward",
            },
            {
              count: 1,
              label: "1 year",
              step: "year",
              stepmode: "backward",
            },
            { step: "all" },
          ],
        },
        rangeslider: { range: [first_date, last_date], thickness: 0.07 },
        type: "date",
      },
      yaxis: {
        title: {
          text: "Active power (kW)",
          standoff: 10,
        },
      },
    };
    // make plot
    Plotly.newPlot("chartResults", charData, layout, {
      displaylogo: false,
    });
  }, 100);

  return (
    <div style={{ padding: "15px 25px 10px 25px", backgroundColor: "white" }}>
      <div
        id="chartResults"
        style={{ width: "100%", height: maxHeight, marginTop: 0 }}
      ></div>
    </div>
  );
};

export default ProductivityChart;
